document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('popup-notice');
  if (!popup) return;

  const closeBtn = document.getElementById('popup-close');

  // Show popup only once per session (on first page load)
  if (!sessionStorage.getItem('popupShown')) {
    setTimeout(() => {
      popup.style.display = 'flex';
      sessionStorage.setItem('popupShown', 'true');
    }, 1000);
  }

  // Close on click
  closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
  });

  // Close if user clicks outside the popup box
  popup.addEventListener('click', function(e) {
    if (e.target === popup) popup.style.display = 'none';
  });
});